<div mat-dialog-title class="header" style="display: flex; justify-content: space-between">
    <div style="display: flex; align-items: flex-start">
        <button (click)="close()">
            <mat-icon aria-hidden="true" style="color: var(--primary-text-color); font-size: 22px">arrow_back</mat-icon>
        </button>
        <div style="display: flex; flex-direction: column">
            <span style="font-size: 14px; font-weight: bold; line-height: 1.4">
                Order #{{ order.order_details.tracking_id }}
            </span>
            <span style="font-size: 12px; font-weight: 500; color: #7c8495; line-height: 2; text-transform: uppercase">
                {{ order.order_details.placed_at * 1000 | date: 'd MMM yyyy, h:mm a' }} |
                {{ order.order_details.total_payable | rupee }}
            </span>
        </div>
    </div>
</div>

<mat-dialog-content>
    <ng-container>
        @if (order.currentStatus !== 'cancelled' && (order.order_details.total_saving_amount || PCDCSavingstext)) {
            <div class="savings-container">
                @if (order.order_details.total_saving_amount) {
                    <div class="center1">
                        <img src="{{ DEPLOY_URL }}/assets/icons/checkmark_black.svg" width="12" height="12" />
                        <span class="content">
                            You’ve saved&nbsp;
                            <span style="color: var(--tertiary-color)">₹{{ order.order_details.total_saving_amount | abs }}</span
                            >&nbsp;on this order</span
                        >
                    </div>
                }
                @if (PCDCSavingstext) {
                    <div style="display: flex; align-items: center">
                        <img src="{{ DEPLOY_URL }}/assets/icons/checkmark_black.svg" width="12" height="12" />
                        <div class="content">
                            <span style="color: var(--tertiary-color)">Zero</span>&nbsp; <span>{{ PCDCSavingstext }}</span
                            >&nbsp;
                        </div>
                    </div>
                }
            </div>
        }
        @if (order.currentStatus === 'cancelled') {
            <div class="savings-container" style="background: #faefef">
                <span class="content" style="color: #cf5c63">Your order has been cancelled</span>
            </div>
        }
        <div style="display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #f2f4f4">
            <div style="display: flex; flex-direction: column">
                <span style="font-size: 12px; font-weight: bold; line-height: 1.4; text-transform: uppercase">{{
                    orderTiming.text
                }}</span>
                <span style="font-size: 12px; font-weight: 500; color: #7c8495; line-height: 2; text-transform: uppercase">{{
                    orderTiming.time * 1000 | date: 'd MMM yyyy, h:mm a'
                }}</span>
            </div>
            @if (order.order_details.encrypted_tracking_id) {
                <div style="display: flex; flex-direction: row" (click)="!downloadingFile && downloadInvoice()">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 8V9.5H3V8H2V9.5C2 10.05 2.45 10.5 3 10.5H9C9.55 10.5 10 10.05 10 9.5V8H9ZM8.5 6L7.795 5.295L6.5 6.585V2.5H5.5V6.585L4.205 5.295L3.5 6L6 8.5L8.5 6Z"
                            fill="#7C8495" />
                    </svg>
                    <div class="download-invoice">Download Invoice</div>
                </div>
            }
        </div>
        @if (refund?.cancellation_reason && order.currentStatus === 'cancelled') {
            <div style="display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #f2f4f4">
                <div class="text-style1" style="line-height: 1.6; margin-bottom: 10px">
                    {{ refund.cancellation_reason }}
                </div>
            </div>
        }
    </ng-container>

    @if (refund?.amount || refund?.credit) {
        <ng-container #refundSection>
            <app-refund-info [refund]="refund" [mailInfo]="mailInfo" [isOrderSummaryPage]="true"></app-refund-info>
        </ng-container>
    }
    @if (order.allowed_to_repeat && order.currentStatus === 'cancelled') {
        <ng-container #reorderSection>
            <div
                style="display: flex; align-items: center; padding: 12px 0; border-bottom: 1px solid #f2f4f4"
                (click)="repeatOrder()">
                <dotlottie-player autoplay="true" loop="true" class="animation" src="{{ lottieUrl }}"> </dotlottie-player>
                <div>
                    <div class="online-payment text-style2">RESTORE CART</div>
                    <span class="text-style1">Cancelled accidentally or need to change your order? No worries!</span>
                </div>
            </div>
        </ng-container>
    }

    <delivery-support [order]="order" [wrapperClass]="'order-summary'"></delivery-support>

    <ng-container>
        <div style="padding: 12px 0; border-bottom: 1px solid #f2f4f4">
            @if (order.order_details.is_delivery) {
                <span class="arrow-up text-style2" style="text-transform: uppercase">Deliver to</span>
                <div style="display: flex; flex-direction: column">
                    <span class="text-style2" style="line-height: 1.8"
                        >{{ order.customer_address.address_type }} | {{ order.customer_address.address_line }}</span
                    >
                    <span class="text-style1" style="line-height: 1.4; color: #7c8495">{{
                        order.customer_address.formatted_locality
                    }}</span>
                </div>
            } @else {
                <span class="arrow-up text-style2" style="text-transform: uppercase">Pick Up from</span>
                <div style="display: flex; flex-direction: column">
                    <span class="text-style2" style="line-height: 2"
                        >{{ order.outlet_address.address_type }} | {{ order.outlet_address.address_line }}</span
                    >
                    <span class="text-style1" style="line-height: 1.4; color: #7c8495">{{
                        order.outlet_address.formatted_locality
                    }}</span>
                </div>
            }
        </div>
    </ng-container>

    <ng-template let-item="item" #productDetails>
        <div class="product-details">
            <div style="display: flex">
                @if (!item.veg) {
                    <img src="{{ DEPLOY_URL }}/assets/images/non-veg.svg" class="item-icon" />
                }
                @if (item.veg) {
                    <img src="{{ DEPLOY_URL }}/assets/images/veg.svg" class="item-icon" />
                }
                <div style="display: flex; flex-direction: column; margin-left: 10px">
                    <span class="text-style1">
                        {{ item.name }}
                    </span>
                    @for (customization of item.customizations | customisationGroup: 'pctg_id'; track customization) {
                        <div class="customisation">
                            <span class="dot"></span>
                            <span>{{ customization }}</span>
                        </div>
                    }
                </div>
            </div>
            <div class="text-style1 flex-end" style="white-space: nowrap">x {{ item.quantity }}</div>
            <div class="text-style1 flex-end">{{ item.cost | rupee }}</div>
        </div>
    </ng-template>

    <ng-container #productListing>
        <div style="padding: 12px 0; border-bottom: 1px solid #f2f2f4">
            <div class="bold-with-margin" style="text-transform: uppercase">Item Details</div>
            @for (brand_detail of brand_details; track brand_detail) {
                <div style="padding: 6px 0">
                    <div class="bold-with-margin">{{ brand_detail.brand_name }}</div>
                    @for (item of menuItems | brandProductFilter: brand_detail.brand_id; track item) {
                        <ng-template [ngTemplateOutlet]="productDetails" [ngTemplateOutletContext]="{ item: item }">
                        </ng-template>
                    }
                </div>
            }
        </div>
    </ng-container>

    @if (freeItemDetails.quantity) {
        <ng-container #freebieSection>
            <div style="padding: 12px 0; border-bottom: 1px solid #f2f4f4">
                <span class="text-style2">FREEBIES</span>
                <div style="display: flex; align-items: center; margin-top: 12px">
                    <img src="{{ DEPLOY_URL }}/assets/images/present.png" style="width: 40px; height: 40px" />
                    <div class="freebie-count">{{ freeItemDetails.quantity }}</div>
                    <span style="font-size: 12px; font-weight: 500; color: #7c8495; line-height: 1.3"
                        >You’ve got {{ freeItemDetails.label }} for FREE!</span
                    >
                </div>
            </div>
        </ng-container>
    }

    <ng-template let-text="text" let-value="value" let-color="color" #singleEntity>
        <div class="space-between">
            <span class="text-style2" [ngStyle]="color ? { color: color } : {}">
                {{ text }}
            </span>
            <span class="text-style2" [ngStyle]="color ? { color: color } : {}">
                {{ value | rupee }}
            </span>
        </div>
    </ng-template>

    <ng-container #billDetails>
        <div class="bill-details">
            <div style="padding: 12px 0; border-bottom: 1px solid #f2f4f4">
                <ng-template
                    [ngTemplateOutlet]="singleEntity"
                    [ngTemplateOutletContext]="{ text: 'Subtotal', value: order.order_details.gross_total }">
                </ng-template>

                @for (charges of order.order_details.bill_details; track charges) {
                    <div
                        class="space-between"
                        [ngStyle]="charges.type === 'discount' ? { color: '#0e7c7b' } : {}"
                        (click)="toggleView(charges.name)">
                        <div>
                            <span class="text-style2 sub-charges" [ngClass]="{ underline: charges.sub_charges.length }">
                                {{ charges.name }}
                            </span>
                            @if (charges.sub_charges.length) {
                                <span class="arrow" [ngClass]="{ active: activeBillDetails === charges.name }"></span>
                            }
                        </div>
                        <span class="text-style2">{{ charges.amount | rupee }}</span>
                    </div>
                    @if (activeBillDetails === charges.name) {
                        @for (sub_charges of charges.sub_charges; track sub_charges) {
                            <ng-template
                                [ngTemplateOutlet]="singleEntity"
                                [ngTemplateOutletContext]="{
                                    text: sub_charges.name,
                                    value: sub_charges.amount,
                                    color: '#7C8495'
                                }"></ng-template>
                        }
                    }
                }
                @if (order.order_details.currency_redeem) {
                    <div class="space-between" style="color: var(--tertiary-color)" #credits>
                        <span class="text-style2">
                            Credits
                            <img
                                src="{{ DEPLOY_URL }}/assets/images/credit-coin.png"
                                style="width: 12px; height: 12px; position: relative; bottom: 2px" />
                        </span>
                        <span class="text-style2"> -{{ order.order_details.currency_redeem | rupee }} </span>
                    </div>
                }
                @if (order.order_details.round_off) {
                    <ng-template
                        [ngTemplateOutlet]="singleEntity"
                        [ngTemplateOutletContext]="{ text: 'Round Off', value: order.order_details.round_off }">
                    </ng-template>
                }
            </div>
            <div style="padding: 12px 0; border-bottom: 1px solid #f2f4f4">
                <div class="space-between total">
                    <span> TOTAL </span>
                    <span>
                        {{ order.order_details.total_payable | rupee }}
                    </span>
                </div>
                @if (order.order_details.total_due) {
                    <ng-template
                        [ngTemplateOutlet]="singleEntity"
                        [ngTemplateOutletContext]="{ text: 'Amount Due', value: order.order_details.total_due }">
                    </ng-template>
                } @else {
                    <ng-template
                        [ngTemplateOutlet]="singleEntity"
                        [ngTemplateOutletContext]="{ text: 'Amount Paid', value: order.order_details.total_payable }">
                    </ng-template>
                }
            </div>
            <div style="padding: 12px 0">
                <div class="space-between">
                    <span class="text-style2" style="color: #7c8495; text-transform: capitalize"> Payment Via </span>
                    <span class="text-style1" style="line-height: 1.8; text-transform: capitalize">
                        {{ order.order_details.payment_mode }}
                    </span>
                </div>
                @if (order.order_details.cashback_amount) {
                    <div class="space-between" style="color: var(--tertiary-color)">
                        <span class="text-style2">
                            CASHBACK
                            <img
                                src="{{ DEPLOY_URL }}/assets/images/credit-coin.png"
                                style="width: 12px; height: 12px; position: relative; bottom: 2px" />
                        </span>
                        <span class="text-style2">
                            {{ order.order_details.cashback_amount | rupee }}
                        </span>
                    </div>
                }
            </div>
            @if (order.order_details.total_due && order.currentStatus !== 'cancelled') {
                <div class="payment-due" (click)="close('make_payment')">
                    <img
                        src="{{ DEPLOY_URL }}/assets/icons/cash_rupee.svg"
                        style="width: 40px; height: 40px; border-radius: 12px" />
                    <div style="display: flex; flex-direction: column; margin-left: 10px">
                        <span style="font-size: 12px; font-weight: bold" class="online-payment"
                            >PAY {{ order.order_details.total_due | rupee }} ONLINE</span
                        >
                        <span class="cashless-text">Go cashless for a hassle-free experience</span>
                    </div>
                </div>
            }
        </div>
    </ng-container>

    @if (order.currentStatus === 'dispatched') {
        <div class="hidden-sm hidden-md hidden-lg sticky-bottom" (click)="close('track_order')">
            <div class="cta">Track Order</div>
        </div>
    }
</mat-dialog-content>
